import { IconButton } from '@material-ui/core';
import { Tooltip } from 'antd';
import React from 'react';
import { useTranslate } from 'react-admin';
import { Check } from '@material-ui/icons';
import { useGetNoPageListData } from '../../../../base/components/customized/CustomizedNoPageList';
import resourceSlug from '../../../../constant/resource-slug';
import { useValidateInvoice } from '../../hooks';

const ValidateButton = ({ invoiceId }) => {
  const t = useTranslate();
  const { refetchListData } = useGetNoPageListData(resourceSlug.INVOICE);

  const {
    validateInvoice,
    isValidating,
    invoiceId: validatedInvoiceId,
  } = useValidateInvoice({
    onSuccess: refetchListData,
  });

  return (
    <Tooltip title={t('resources.invoice.validateTooltip')}>
      <IconButton
        size="small"
        color="primary"
        disabled={isValidating && validatedInvoiceId === invoiceId}
        onClick={(e) => {
          e.stopPropagation();
          validateInvoice(invoiceId);
        }}
      >
        <Check />
      </IconButton>
    </Tooltip>
  );
};

export default ValidateButton;
